import React, { useState } from 'react';
import { X, RefreshCw, Info } from 'lucide-react';

export default function CrearIR13Modal({ onClose, onConfirm, generating }) {
  const currentYear = new Date().getFullYear();
  const [anio, setAnio]                     = useState(currentYear - 1);
  const [incluirInactivos, setIncluirInactivos] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(anio, incluirInactivos);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md">

        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
          <div>
            <h2 className="text-base font-bold text-gray-900">Generar IR-13</h2>
            <p className="text-xs text-gray-400 mt-0.5">Declaración Jurada Anual de Retenciones ISR</p>
          </div>
          <button
            onClick={onClose}
            disabled={generating}
            className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X size={16} className="text-gray-500" />
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} className="px-5 py-5 space-y-4">

          {/* Año fiscal */}
          <div>
            <label className="block text-xs font-semibold text-gray-700 mb-1.5">
              Año Fiscal <span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              value={anio}
              onChange={e => setAnio(parseInt(e.target.value, 10))}
              min={2020}
              max={currentYear}
              required
              className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-blue-400"
            />
            <p className="text-xs text-gray-400 mt-1">Consolidará todas las nóminas cerradas del año seleccionado.</p>
          </div>

          {/* Incluir inactivos */}
          <label className="flex items-start gap-3 cursor-pointer group">
            <input
              type="checkbox"
              checked={incluirInactivos}
              onChange={e => setIncluirInactivos(e.target.checked)}
              className="mt-0.5 w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
            />
            <div>
              <p className="text-sm font-medium text-gray-700 group-hover:text-gray-900">Incluir empleados inactivos</p>
              <p className="text-xs text-gray-400">Por defecto solo se incluyen empleados activos.</p>
            </div>
          </label>

          {/* Info box */}
          <div className="flex items-start gap-2 bg-blue-50 border border-blue-200 rounded-lg px-3 py-2.5">
            <Info size={14} className="text-blue-500 mt-0.5 flex-shrink-0" />
            <p className="text-xs text-blue-700">
              Si ya existe un IR-13 en borrador para el año seleccionado, será reemplazado. Los IR-13 cerrados no pueden regenerarse.
            </p>
          </div>

          {/* Actions */}
          <div className="flex gap-3 pt-1">
            <button
              type="button"
              onClick={onClose}
              disabled={generating}
              className="flex-1 px-4 py-2 border border-gray-200 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition-colors"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={generating}
              className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-semibold hover:bg-blue-700 disabled:opacity-60 transition-colors"
            >
              {generating ? (
                <>
                  <RefreshCw size={14} className="animate-spin" />
                  Generando…
                </>
              ) : 'Generar IR-13'}
            </button>
          </div>
        </form>

      </div>
    </div>
  );
}
